import Box from "@mui/material/Box";
import styled, { keyframes } from "styled-components";
import { deviceSpec } from "breakpoints";
import { Paper } from "@mui/material";

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const DecommissionBanner = styled.div`
  width: 100%;
  padding: 12px 24px;
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 50%, #f59e0b 100%);
  background-size: 200% 100%;
  animation: ${shimmer} 8s ease-in-out infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .banner-icon {
    font-size: 1.1rem;
    flex-shrink: 0;
  }

  .banner-text {
    font-size: 0.85rem;
    font-weight: 600;
    color: #1a1a1a;
    letter-spacing: 0.01em;
    text-align: center;
    line-height: 1.4;

    a {
      color: #1a1a1a;
      text-decoration: underline;
      text-underline-offset: 2px;
      font-weight: 700;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.75;
      }
    }
  }
`;

export const ApplicationRootStyle = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  .Toastify {
    .Toastify__toast-container {
      width: 100%;
      position: relative;
      z-index: 100;
      padding: 0;
      top: 0;

      .Toastify__toast {
        margin: 0;
        min-height: min-content;
        position: absolute;
        width: 100%;
        top: calc((var(--nth) - 1) * 12px);
      }
    }

    .Toastify__close-button {
      align-self: center;
    }
  }

  .rs-picker-input-group, .rs-picker-input-group input {
    border: 1px solid ${({theme}) => theme.colors.actionButtonColor};
    height: 30px;
    background-color: transparent;
    color: ${({theme}) => theme.colors.textColor};
  }

  .rs-calendar-table-cell-content {
    span {
      color: ${({theme}) => theme.colors.textColor}; 
    }
  }
  
  .Toastify__toast-icon {
    svg {
      color: white;
    }
  }
`;

export const Wrapper1 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Main1 = styled.div`
  width: 100%;
  height: 150vh;
`;

export const Sidebar1 = styled.div`
  position: sticky;
  top: 0;
  height: 125vh;
`;

export const ComponentsAndHeaderRootStyles = styled.main`
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
`;

export const Main = styled.main`
  display: grid;
  grid-template-columns: auto 1fr;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const Body = styled.body`
  overflow: hidden;
`;

// For the tooltip, which is currently unused
export const TooltipContainer = styled.div<{ visible: string, top: number, right: number }>`
  position: absolute;
  z-index: 2;
  display: ${(props) => (props.visible === "true" ? "inherit" : "none")};
  top: ${(props) => props.top}px;
  left: ${(props) => props.right}px;

  @media ${deviceSpec.isTablet} {
    display: none;
  }
`;

export const TooltipContentSpan = styled('span')`
    display: flex;
    align-items: flex-start;
    z-index: 10001;
    margin-left: 10px;

    .pointer-left {
      height: 0.75rem;
      width: 0.75rem;
      transform: rotate(45deg);
      border-radius: 0 0 0 4px;
      position: relative;
      top: 15%;
      background-color: ${({theme}) => theme.colors.dark};
      left: 0.375rem;
    }
`;
